import React from 'react';
import {
  BaseLabel,
  Label,
  RowContainer,
  InputSmall,
  Select,
} from '../../../../styles/styleUtils';

const PERIODICIDADES = [
  ['quinzenal', 'Quinzenal'],
  ['mensal', 'Mensal'],
  ['bimestral', 'Bimestral'],
  ['trimestral', 'Trimestral'],
  ['semestral', 'Semestral'],
  ['anual', 'Anual'],
];

function RecorrenciaReceita({ formData, onInputChange, disabled }) {
  const quantidade = Number(formData.quantidadeRecorrencias || 0);
  const valor = Number(formData.valor || 0);
  const total = quantidade > 0 && valor > 0 ? quantidade * valor : 0;

  return (
    <>
      <RowContainer>
        <BaseLabel htmlFor="quantidadeRecorrencias">Quantidade de competências</BaseLabel>
        <InputSmall
          type="number"
          min="2"
          max="120"
          id="quantidadeRecorrencias"
          name="quantidadeRecorrencias"
          value={formData.quantidadeRecorrencias || 2}
          onChange={onInputChange}
          disabled={disabled}
        />

        <div style={{ width: 70 }} />

        <Label htmlFor="periodicidade">Periodicidade</Label>
        <Select
          id="periodicidade"
          name="periodicidade"
          value={formData.periodicidade || ''}
          onChange={onInputChange}
          disabled={disabled}
        >
          <option value="">Selecione</option>
          {PERIODICIDADES.map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </Select>
      </RowContainer>

      <RowContainer>
        <BaseLabel>Resumo da recorrência</BaseLabel>
        <span>
          {quantidade >= 2 && formData.periodicidade
            ? `${quantidade} cobranças de ${valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })} — total previsto ${total.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}`
            : 'Informe quantidade e periodicidade.'}
        </span>
      </RowContainer>
    </>
  );
}

export default RecorrenciaReceita;
